import React, { memo, useCallback, useMemo } from 'react';
import logo from '../../../assets/img/logo_uget_black.png';
import Button from '../../bootstrap/Button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import TableDash from '../../MyCustom/TableSimples';
import Money from '../../../helpers/utils/money/money';

const ModalPriceUpdatePreview = ({
  open,
  setIsOpen,
  setIsClose,
  rows,
  invalidRows,
  onConfirm,
  loading,
}) => {
  const handleClose = useCallback(() => {
    if (!loading) setIsClose();
  }, [loading, setIsClose]);

  const rowsToUpdateCount = useMemo(() => (
    rows.filter((item) => item.newPrice !== item.oldPrice).length
  ), [rows]);

  const handleConfirm = useCallback(() => {
    if (!loading && rowsToUpdateCount > 0) onConfirm();
  }, [loading, onConfirm, rowsToUpdateCount]);

  const columns = useMemo(() => ([
    {
      label: 'Imagem',
      field: 'image_url',
      format: row => (
        <>
          {row.image_url ? (
            <img src={row.image_url} alt='Imagem' width={28} height={54} />
          ) : (
            <img src={logo} alt='Imagem' width={30} height='auto' />
          )}
        </>
      ),
      noExport: true,
    },
    {
      label: 'Produto',
      field: 'name',
    },
    {
      label: 'Status',
      field: '{row}',
      format: (row) => (
        <span className={`badge ${row.active ? 'bg-success' : 'bg-danger'}`}>
          {row.active ? 'Ativo' : 'Inativo'}
        </span>
      ),
      formatExport: (row) => (row.active ? 'Ativo' : 'Inativo'),
    },
    {
      label: 'Preço antigo',
      field: 'oldPriceLabel',
    },
    {
      label: 'Preço novo',
      field: 'newPriceLabel',
    },
    {
      label: 'Diferença',
      field: 'diffLabel',
    },
  ]), []);

  const rowsRender = useMemo(() => (
    rows.map((item) => ({
      id: `${item.id}-${item.newPrice}`,
      image_url: item.image_url,
      idFromSheet: item.idFromSheet,
      name: item.name,
      active: !!item.active,
      oldPriceLabel: Money.centsToMaskMoney(item.oldPrice),
      newPriceLabel: Money.centsToMaskMoney(item.newPrice),
      diffLabel: `${item.newPrice >= item.oldPrice ? '+' : '-'} ${Money.centsToMaskMoney(Math.abs(item.newPrice - item.oldPrice))}`,
    }))
  ), [rows]);

  return (
    <Modal
      id='modal-update-product-prices'
      titleId='Atualizar Preços'
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop
      isScrollable
      isCentered
      size='xl'
      isAnimation>
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id='update-prices-preview'>Conferência de Atualização de Preços</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p className='mb-2'>
          Foram lidos <strong>{rows.length}</strong> produto(s).{' '}
          <strong>{rowsToUpdateCount}</strong> terão preço alterado.
        </p>
        {invalidRows.length > 0 && (
          <p className='mb-3 text-warning'>
            {invalidRows.length} linha(s) foram ignoradas por inconsistência.
          </p>
        )}
        <div className='table-responsive' style={{ maxHeight: 420, overflowY: 'auto' }}>
          <TableDash
            columns={columns}
            rows={rowsRender}
            keyExtractor={(item) => item.id}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color='danger'
          icon='cancel'
          rounded={1}
          hoverShadow='sm'
          shadow='sm'
          size='sm'
          isDisable={loading}
          onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          color='success'
          icon='check'
          rounded={1}
          hoverShadow='sm'
          shadow='sm'
          size='sm'
          isDisable={loading || rowsToUpdateCount === 0}
          onClick={handleConfirm}>
          {loading ? 'Atualizando...' : 'Confirmar atualização'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default memo(ModalPriceUpdatePreview);
